import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './allDoctors.module.scss';
import arrow_down from '../../static/images_pfizer/assistant/arrow_down.png'
import green_arrow_right from '../../static/images_pfizer/assistant/green_arrow_right.png'
import assistant_doctor_avatar from '../../static/images_pfizer/assistant/assistant_doctor_avatar.png'
import doctor_not_active_avatar from '../../static/images_pfizer/assistant/doctor_not_active_avatar.png';
import icon_plus from '../../static/images_pfizer/assistant/icon_plus.png';
import doctor_related from '../../static/images_pfizer/assistant/doctor_related.png';
import doctor_wait_confirm from '../../static/images_pfizer/assistant/doctor_wait_confirm.png';
import doctor_not_auth from '../../static/images_pfizer/assistant/doctor_not_auth.png';
import doctor_not_active from '../../static/images_pfizer/assistant/doctor_not_active.png';
import { Button } from 'antd-mobile-v5';
import  { ApiCore } from '../../api/index';
import choose_project_icon from '../../static/images_pfizer/assistant/choose_project_icon.png';
import { Radio, Space } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
const api = new ApiCore();

function AllDoctors(props: any) {

    const [list, setList] = useState([]);
    const [groupList, setGroupList] = useState<any>([]);
    const [selectedItem, setSelectedItem] = useState<any>({});
    const [radioValue, setRadioValue] = useState<any>('');
    const [showChooseProject, setShowChooseProject] = useState(false);

    useEffect(() => {
        document.title = '全部医生';
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        api.getTeamAllDoctors().then((res: any) => {
            if (res.code == 0) {
                setList(res.data);
            }
        });
    }

    const renderImg = (status: string | number) => {
        if (status == 4) {
            return <img src={doctor_related} alt="" />
        } else if (status == 3) {
            return <img src={doctor_wait_confirm} alt="" />
        } else if (status == 2) {
            return <img src={doctor_not_auth} alt="" />
        } else if (status == 1) {
            return <img src={doctor_not_active} alt="" />
        }
        return null;
    }

    const renderText = (status: string | number) => {
        if (status == 1) {
            return '未激活'
        } else if (status == 2) {
            return '未授权'
        } else if (status == 3) {
            return '待确认'
        } else if (status == 4) {
            return '已关联'
        }
        return null;
    }

    const renderTip = (val: any) => {
        let _state =  val.state;
        let _tasks =  val.groupTasks;
        if (_state == 1) {
            return '去邀请';
        } else if (_state == 2) {
            return '申请关联';
        } else if (_state == 3) {
            return '已申请，等待医生确认';
        } else if (_state == 4) {
            if (_tasks && (_tasks.length > 0)) {
                return '';
            }
            return '未分配项目，立即分配';
        }
        return null;
    }

    const renderTipSymbol = (val: any) => {
        let _state =  val.state;
        let _tasks =  val.groupTasks;
        if (_state == 4) {
            if (_tasks && (_tasks.length > 0)) {
                return '';
            }
        }
        return '>>';
    }

    const renderColor = (status: string | number) => {
        if (status == 1) {
            return 'rgba(0, 0, 0, 0.5000)';
        } else if (status == 2) {
            return '#DE9100';
        } else if (status == 3) {
            return '#4E88F5';
        } else if (status == 4) {
            return '#13C2C2';
        }
        return null;
    }

    const toShowProject = () => {
        setShowChooseProject(true);
    }

    const toRelation = (val: any) => {
        if (val.state == 2) {
            setSelectedItem(val);
            toShowProject();
            api.getAssistantGroupSelect().then((res: any) => {
                if (res.code == 0) {
                    setGroupList(res.data || []);
                }
            });
        }
    }

    const toApply = () => {
        if (!radioValue) {
            Toast.info('请阅读并勾选需要加入的项目', 0.8);
            return;
        }
        api.submitTeamBindDoctor({
            doctorCode: selectedItem.doctorCode,
            groupCode: radioValue
        }).then((res: any) => {
            if (res.code == 0) {
                Toast.info('邀请成功');
                setShowChooseProject(false);
            } else {
                Toast.info(res.message || '邀请失败');
            }
        });
    }

    const radioChange = (val: any) => {
        setRadioValue(val);
    }

    return (
        <div className={`${styles.workbench_content}`}>
            <div className={styles.head_middle}>
                <div className={styles.middle_left}>
                    <div className={styles.left_text}>我的医生</div>
                </div>
                <div className={styles.middle_right} onClick={ () => { props.history.push('/pfizer/assistant/addDoctor'); } }>
                    <img src={icon_plus} alt="" />
                    <span>添加医生</span>
                </div>
            </div>
            <div className={styles.head_content}>
                {
                    list && (list || []).map((val: any, key: number) => (
                    <div key={key} className={styles.content_card}>
                        <div className={styles.card_top}>
                            <div className={styles.top_left}>
                                <img src={val.state != 1 ? assistant_doctor_avatar : doctor_not_active_avatar} alt="" />
                            </div>
                            <div className={styles.top_middle}>
                                <div className={styles.top_middle_head}>
                                    <span>{val.doctorName}</span>
                                    {/* <div className={styles.top_middle_head_active_btn}>活跃中</div> */}
                                    <div className={styles.top_middle_head_related}>
                                        {renderImg(val.state)}
                                        <span style={{ color: `${renderColor(val.state)}` }}>{renderText(val.state)}</span>
                                    </div>
                                </div>
                                <div className={styles.top_middle_middle}>
                                    <span>{val.hospital}</span>
                                    <span>{val.dept}</span>
                                </div>
                                {
                                    val.hasProject ? 
                                    <div className={styles.top_middle_bottom}>
                                        <span>(NP / OP)</span>
                                        <span>28 / 37</span>
                                    </div>
                                    :
                                    <div className={styles.top_middle_bottom2}>
                                        <span className={styles.top_middle_bottom_text} onClick={() => { toRelation(val) }}>{val.text}{renderTip(val)}</span>
                                        <span className={styles.top_middle_bottom_symbol} onClick={() => { toRelation(val) }}>{renderTipSymbol(val)}</span>
                                    </div>
                                }

                            </div>
                            <div className={styles.top_right}>
                            </div>
                        </div>
                    </div>
                    ))
                }
                
            </div>
            {
                showChooseProject && 
                <>
                    <div className={styles.cover_mask}></div>
                    <div className={styles.choose_project_card}>
                        <img className={styles.choose_project_card_img} src={choose_project_icon} alt="" />
                        <div className={styles.choose_project_title}>申请成为医助</div>
                        <div className={styles.title}>
                            <span>请选择要加入的项目</span>
                        </div>
                        <div className={styles.sub_title}>
                            <span>申请后请等待医生对您的申请进行授权</span>
                        </div>
                        <div className={styles.group_list}>
                            <Radio.Group value={radioValue}  onChange={(val) => { radioChange(val) }}>
                                <Space direction='vertical'>
                                    {
                                        groupList && groupList.map((val: any, key: number) => (
                                            <Radio key={key} style={{color: '#757575'}} value={val.code}>
                                                <div className={styles.radio_title}>
                                                    {val.name}
                                                </div>
                                                {
                                                    radioValue === val.code && 
                                                    <div className={styles.radio_remark}>
                                                        {val.remark}
                                                    </div>
                                                }
                                            </Radio>
                                        ))
                                    }
                                </Space>
                            </Radio.Group>
                        </div>
                        <div className={styles.choose_project_target_btn}>
                            <div>
                                <Button onClick={() => {
                                    setShowChooseProject(false);
                                }}>返回</Button>
                            </div>
                            <div>
                                <Button onClick={() => {
                                    toApply()
                                }}>发送申请</Button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )

}

export default AllDoctors;